import { createContext, useContext, useSyncExternalStore } from 'react';

import type { AppState, Store } from '../store.js';

const StoreCtx = createContext<Store | null>(null);

export const StoreProvider = StoreCtx.Provider;

export function useStore(): Store {
  const store = useContext(StoreCtx);
  if (!store) throw new Error('useStore must be used inside <StoreProvider>');
  return store;
}

export function useAppState(): AppState {
  const store = useStore();
  return useSyncExternalStore(store.subscribe, store.getState, store.getState);
}
